import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginWithOtpComponent, OtpMode } from '../../shared/login-with-otp/login-with-otp.component';

@Component({
    selector: 'app-otp-demo',
    imports: [
        CommonModule,
        LoginWithOtpComponent
    ],
    template: `
    <div class="demo-container">
      <div class="demo-header">
        <h1>OTP Component Demo</h1>
        <p>Responsive OTP Component - Test both Login and Forgot Password modes</p>
      </div>
      
      <div class="demo-controls">
        <button 
          [class.active]="currentMode === 'login'"
          (click)="setMode('login')"
          class="mode-btn">
          Login Mode
        </button>
        <button 
          [class.active]="currentMode === 'forgot-password'"
          (click)="setMode('forgot-password')"
          class="mode-btn">
          Forgot Password Mode
        </button>
      </div>
      
      <div class="demo-content">
        <app-login-with-otp 
          [mode]="currentMode"
          (switchToRegular)="onSwitchToRegular()"
          (passwordResetSuccess)="onPasswordResetSuccess($event)">
        </app-login-with-otp>
      </div>
    </div>
  `,
    styles: [`
    .demo-container {
      min-height: 100vh;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: clamp(1rem, 3vw, 2rem);
    }

    .demo-header {
      text-align: center;
      margin-bottom: clamp(1rem, 3vw, 2rem);
      color: white;
    }

    .demo-header h1 {
      font-size: clamp(1.5rem, 4vw, 2.5rem);
      margin-bottom: clamp(0.5rem, 1.25vw, 1rem);
      font-weight: 600;
    }

    .demo-header p {
      font-size: clamp(0.875rem, 2vw, 1.125rem);
      opacity: 0.9;
    }

    .demo-controls {
      display: flex;
      gap: clamp(0.5rem, 1.5vw, 1rem);
      margin-bottom: clamp(1rem, 3vw, 2rem);
    }

    .mode-btn {
      padding: clamp(0.5rem, 1.5vw, 1rem) clamp(1rem, 2.5vw, 1.5rem);
      border: 2px solid white;
      background: transparent;
      color: white;
      border-radius: clamp(0.25rem, 1vw, 0.5rem);
      cursor: pointer;
      font-size: clamp(0.75rem, 2vw, 1rem);
      transition: all 0.2s ease;
    }

    .mode-btn:hover {
      background: rgba(255, 255, 255, 0.1);
    }

    .mode-btn.active {
      background: white;
      color: #667eea;
    }

    .demo-content {
      width: 100%;
      max-width: clamp(20rem, 90vw, 28rem);
    }

    /* Responsive adjustments */
    @media (max-width: 48rem) {
      .demo-container {
        padding: 1rem;
      }
      
      .demo-header {
        margin-bottom: 1.5rem;
      }

      .demo-controls {
        flex-direction: column;
        align-items: center;
      }
    }
  `]
})
export class OtpDemoComponent {
  currentMode: OtpMode = 'login';

  setMode(mode: OtpMode) {
    this.currentMode = mode;
  }

  onSwitchToRegular() {
    console.log('Switching back to regular login');
  }

  onPasswordResetSuccess(data: {mobile: string}) {
    console.log('Password reset successful:', data);
    alert(`Password reset successful! A new password has been sent to mobile: ${data.mobile}`);
  }
} 